import meter1 from "../assets/img/meter1.svg";
import meter2 from "../assets/img/meter2.svg";
import meter3 from "../assets/img/meter3.svg";
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import arrow1 from "../assets/img/arrow1.svg";
import arrow2 from "../assets/img/arrow2.svg";
import colorSharp from "../assets/img/color-sharp.png"
import { buildStyles, CircularProgressbar} from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 10
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1
    }
  };
  const gradient = `linear-gradient(to right, rgba(274, 21, 41, 0.9) 50%, #ffffff 50%)`;


  return (
    <section className="skill" id="skills">
        <div className="container">
            <div className="row">
                <div className="col-12">
                    <div className="skill-bx wow zoomIn">
                        <h2>Skills</h2>

                        {/* <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry.<br></br> Lorem Ipsum has been the industry's standard dummy text.</p> */}

                        <p>
                        I have strong skills in HTML, CSS, JavaScript, and Bootstrap, and a deep understanding of React for building dynamic and responsive web applications. I am dedicated to staying up-to-date with the latest industry advancements and delivering high-quality work as a Front End Developer.
                        </p>
                        <Carousel responsive={responsive} infinite={true} className="owl-carousel owl-theme skill-slider">
                            <div className="item">
                                <CircularProgressbar className="bars" value={90} text={`${90}%`}  styles={buildStyles({  pathColor: gradient, trailColor: '#f0f0f0',})} />

                                <h5>HTML</h5>
                            </div>
                            <div className="item">
                                <CircularProgressbar className="bars" value={90} text={`${90}%`} />

                                <h5>CSS</h5>
                            </div>
                            <div className="item">
                                <CircularProgressbar className="bars" value={90} text={`${90}%`} />

                                <h5>javaScript</h5>
                            </div>
                            <div className="item">
                                <CircularProgressbar className="bars" value={90} text={`${90}%`} />

                                <h5>bootstrap</h5>
                            </div>
                            <div className="item">
                                <CircularProgressbar className="bars" value={80} text={`${80}%`} />

                                <h5>React</h5>
                            </div>
                        </Carousel>
                    </div>
                </div>
            </div>
        </div>
        <img className="background-image-left" src={colorSharp} alt="Image" />
    </section>
  )
}
